module.exports = __webpack_public_path__ + "img/Falkberget_Paul_Ottar_Haga.544bb3f7.jpg";